<div class="controls-panel">
  <div class="title">
    <h3>Tests <i [style]="{opacity: loading ? 1 : 0}" class="fas fa-sync fa-spin text-muted title-spinner"></i></h3>
  </div>
  <div class="controls"></div>
</div>
<div #chartContainer>
  <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="setChart($event)"></highcharts-chart>
</div>
